"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const Photo_1 = __importDefault(require("@material-ui/icons/Photo"));
const Attachment_1 = __importDefault(require("@material-ui/icons/Attachment"));
const stateFunctions_1 = require("../../domain/stateFunctions");
const messageFunctions_1 = require("../../domain/messageFunctions");
const MediaContent_1 = __importDefault(require("./MediaContent"));
const CyclesContent_1 = require("./CyclesContent");
const useStyles = makeStyles_1.default((theme) => ({
    container: {
        cursor: props => props.showPointer ? "pointer" : "default",
        overflow: "hidden",
        borderLeftColor: props => colorManipulator_1.lighten(theme.colors.green.main, props.sentByMe ? 0.4 : 0.0),
        borderLeftWidth: 4,
        borderLeftStyle: "solid",
        fontSize: 14,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    textContainer: {
        padding: "4px 8px",
        minWidth: 120
    },
    text: {
        maxHeight: 72,
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
        display: "-webkit-box",
        "-webkit-line-clamp": 2,
        "-webkit-box-orient": "vertical"
    },
    by: {
        color: props => colorManipulator_1.lighten(theme.colors.green.main, props.sentByMe ? 0.4 : 0.0)
    },
    mediaContent: {
        borderTopRightRadius: "inherit",
        borderBottomRightRadius: "inherit",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        maxWidth: 120,
        maxHeight: 72,
        height: "auto",
        width: "auto"
    },
    cyclesIcon: {
        marginLeft: 12,
        marginRight: 12,
        fontSize: 50
    },
    icon: {
        verticalAlign: "top",
        display: "inline-block",
        width: 20,
        height: 20,
        marginRight: 3
    }
}));
exports.default = react_1.default.memo(MessageReplyPanel);
function MessageReplyPanel(props) {
    var _a;
    let styleProps = {
        sentByMe: props.sentByMe,
        showPointer: props.onClick != undefined
    };
    let chatSubject;
    if (props.isPrivateReply) {
        chatSubject = react_redux_1.useSelector((state) => stateFunctions_1.getChatSubject(state.chatsState, props.repliesToChatId));
    }
    const classes = useStyles(styleProps);
    let text = messageFunctions_1.getContentAsText(props.content);
    let by = props.repliesToMyMessage ? "You" : (_a = props.repliesToUsername) !== null && _a !== void 0 ? _a : "Unknown";
    if (chatSubject) {
        by += " - " + chatSubject;
    }
    const className = props.className + " " + classes.container;
    let rightContent;
    let icon;
    if (props.content.kind === "media") {
        rightContent = react_1.default.createElement(MediaContent_1.default, { content: props.content, className: classes.mediaContent, ownsBlob: false });
        icon = react_1.default.createElement(Photo_1.default, { className: classes.icon });
    }
    else if (props.content.kind === "cycles") {
        rightContent = react_1.default.createElement("div", { className: classes.cyclesIcon }, "\uD83C\uDF89");
        text = CyclesContent_1.formatCyclesText(props.content.amount, props.repliesToMyMessage, props.theirUsername);
    }
    else if (props.content.kind === "file") {
        icon = react_1.default.createElement(Attachment_1.default, { className: classes.icon });
    }
    return (react_1.default.createElement("div", { className: className, onClick: props.onClick },
        react_1.default.createElement("div", { className: classes.textContainer },
            react_1.default.createElement("div", { className: classes.by }, by),
            react_1.default.createElement("div", { className: classes.text },
                icon,
                text)),
        rightContent));
}
